// import VueGtag from "vue-gtag";
import amplitude from "amplitude-js";

export const saveAnalytics = (data) => {
  // console.log('analytics: ', data)
  // if (data.eventAction !== "VIEWED_SUPER") {
  // await this.$ga.event({
  //   eventCategory: data.eventCategory,
  //   eventAction: data.eventAction,
  //   eventLabel: data.eventLabel,
  //   value: parseInt(data.value || 0)
  // });
  // window.gtag('event', data.eventAction, {
  //   eventCategory: data.eventCategory,
  //   eventAction: data.eventAction,
  //   eventLabel: data.eventLabel,
  //   value: parseInt(data.value || 0),
  //   utm_source: data.utm_source || '',
  //   utm_medium: data.utm_medium || '',
  //   utm_campaign: data.utm_campaign || '',
  // })
  // }

  // eslint-disable-next-line
  amplitude.getInstance().logEvent(data.eventAction, data);
  // window.fbq("trackCustom", data.eventAction, {
  //   currency: "BRL",
  //   value: parseFloat(data.value || 0)
  // });
  // if (data.eventAction === "CREATE-NEW-LEAD") {
  //   window.fbq("track", "Lead", {
  //     currency: "BRL",
  //     value: parseFloat(data.value / 3 || 0)
  //   });
  // } else if (data.eventAction === "SIGN-CONTRACT") {
  //   window.fbq("track", "Purchase", {
  //     currency: "BRL",
  //     value: parseFloat(data.value || 0)
  //   });
  //   window.gtag('event', 'conversion', {
  //     // "transaction_id": data.transaction_id,
  //     "send_to": "onboard-enercred",
  //     currency: "BRL",
  //     "value": parseFloat(data.value || 0)
  //   })
  // } else if (data.eventAction === "CREATE-NEW-USER") {
  //   window.fbq("track", "Subscribe", {
  //     currency: "BRL",
  //     value: parseFloat(data.value || 0),
  //     predicted_ltv: parseFloat(data.value * 24 || 0)
  //   });
  // } else if (data.eventAction === "CREATE-NEW-CARD") {
  //   window.fbq("track", "AddPaymentInfo", {
  //     currency: "BRL",
  //     value: parseFloat(data.value * 2 || 0)
  //   });
  // }

  if (data.boleto) {
    data.eventCategory = "super";
    (data.eventAction = "ACCEPT_BOLETO"),
      (data.eventLabel = "ACCEPT_BOLETO_PHONE"),
      // window.gtag('event', data.eventAction, {
      //   eventCategory: data.eventCategory,
      //   eventAction: data.eventAction,
      //   eventLabel: data.eventLabel,
      //   value: parseInt(data.value || 0),
      //   utm_source: data.utm_source || '',
      //   utm_medium: data.utm_medium || '',
      //   utm_campaign: data.utm_campaign || '',
      // })
      amplitude.getInstance().logEvent(data.eventAction, data);
  }
};
